// components/Loader.js
import React from "react";

const Loader = () => {
  return (
    <div className="flex items-center justify-center h-screen dark:text-white">
      <div>Loading...</div>
    </div>
  );
};

export default Loader;
